import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { AccountGeoLocationAddressPipeModule } from '@main-client/src/app/pipes/account-geo-location-address-pipe/account-geo-location-address-pipe.module';
import { AccountJobTitlePipeModule } from '@main-client/src/app/pipes/account-job-title-pipe/account-job-title-pipe.module';
import { AccountOrganizationNamePipeModule } from '@main-client/src/app/pipes/account-organization-name-pipe/account-organization-name-pipe.module';
import { AccountReadableEducationPipeModule } from '@main-client/src/app/pipes/account-readable-education-pipe/account-readable-education-pipe.module';
import { LinkifyPipeModule } from '@main-client/src/app/pipes/linkify-pipe/linkify-pipe.module';
import { ProfileIntroEditDialogModule } from '@main-client/src/app/profile/profile-intro-edit-dialog/profile-intro-edit-dialog.module';

import { ProfileBasicInfoComponent } from './profile-basic-info.component';

@NgModule({
  declarations: [ProfileBasicInfoComponent],
  exports: [ProfileBasicInfoComponent],
  imports: [
    AccountGeoLocationAddressPipeModule,
    AccountJobTitlePipeModule,
    AccountReadableEducationPipeModule,
    AccountOrganizationNamePipeModule,
    CommonModule,
    FlexLayoutModule,
    LinkifyPipeModule,
    MatIconModule,
    MatTooltipModule,
    ProfileIntroEditDialogModule,
  ],
})
export class ProfileBasicInfoModule {}
